import React from 'react';
import Layout from '../../components/shared/layout-fresh-chat';
import SEO from '../../components/SEO/SEO';
import styled from '@emotion/styled';
import { wrapper, color } from '../../utils/style';

const Wrapper = styled('div')`
  ${wrapper}
  margin: 30px auto;
  position:relative;
  .live-chat-popup {
    position: fixed;
    background: ${color.black};
    top: 70px;
    left: 0;
    width: 100%;
    height: calc(100% - 120px);
    z-index: 100;      
    & > iframe {
      height: 100%;
      width: 100%;
      border: 0;
    }
  }
`;

const FreshChatTemplate = () => {
  return (
    <Layout>
      <SEO title="Fresh chat" description="Please chat with us here!" />
      <Wrapper>
        <div className="live-chat-popup">
          <iframe id="chat-frame" title={"Freshchat"} className="chat-frame" src={process.env.FRESHCHAT_IFRAME_SRC} />
        </div>
      </Wrapper>
    </Layout>
  );
};

export default FreshChatTemplate;
